import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'booking.tickets.title',
    defaultMessage: 'Guests',
  },
});
